import React from 'react';
interface FooterProps {
  setPage: (page: 'home' | 'about' | 'contact') => void;
}
export function Footer({
  setPage
}: FooterProps) {
  return <footer className="bg-primary text-white pt-16 pb-8" data-id="element-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-9">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-10">
          {/* Brand & Info */}
          <div data-id="element-11">
            <span className="font-heading text-2xl font-bold text-accent tracking-tight block mb-4" data-id="element-12">
              [CLINIC NAME]
            </span>
            <p className="text-gray-300 mb-6 max-w-sm" data-id="element-13">
              Helping men regain their energy, focus, and drive through
              personalized telehealth TRT.
            </p>
            <div className="space-y-2 text-gray-300" data-id="element-14">
              <p data-id="element-15">📍 [CITY], [STATE]</p>
              <p data-id="element-16">📞 [PHONE]</p>
              <p data-id="element-17">✉️ [EMAIL]</p>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-18">
            <h3 className="font-heading text-xl font-semibold mb-4 text-white" data-id="element-19">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-20">
              <li data-id="element-21">
                <button onClick={() => setPage('home')} className="text-gray-300 hover:text-accent transition-colors" data-id="element-22">
                  Home
                </button>
              </li>
              <li data-id="element-23">
                <button onClick={() => setPage('about')} className="text-gray-300 hover:text-accent transition-colors" data-id="element-24">
                  About & Treatments
                </button>
              </li>
              <li data-id="element-25">
                <button onClick={() => setPage('contact')} className="text-gray-300 hover:text-accent transition-colors" data-id="element-26">
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Hours / Service Area */}
          <div data-id="element-27">
            <h3 className="font-heading text-xl font-semibold mb-4 text-white" data-id="element-28">
              Telehealth Services
            </h3>
            <p className="text-gray-300 mb-4" data-id="element-29">
              Providing secure, confidential telehealth consultations for men in
              [STATE].
            </p>
            <button onClick={() => setPage('contact')} className="text-accent font-semibold hover:text-white transition-colors flex items-center" data-id="element-30">
              Schedule your consultation →
            </button>
          </div>
        </div>

        {/* Compliance & Copyright */}
        <div className="border-t border-slate-700 pt-8 mt-8 text-sm text-gray-400 text-center" data-id="element-31">
          <p className="mb-4 max-w-4xl mx-auto leading-relaxed" data-id="element-32">
            <strong data-id="element-33">Important Notice:</strong> This site is for general
            information and appointment requests only. Medical information is
            collected exclusively through a secure telehealth system. Do not
            submit sensitive medical data through this website.
          </p>
          <p data-id="element-34">
            &copy; {new Date().getFullYear()} [CLINIC NAME]. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}